var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{staticStyle:{"z-index":"99999"},attrs:{"hide-footer":"","id":"filter-modal","size":"lg","title":_vm.title}})
}
var staticRenderFns = []

export { render, staticRenderFns }